const JobIcon = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8099 5.7193H16.0694V3.72343C16.0694 2.7731 15.3295 2 14.4199 2H9.58001C8.67048 2 7.93052 2.7731 7.93052 3.72343V5.7193H3.19009C1.98245 5.7193 1 6.74586 1 8.00763V19.7117C1 20.9735 1.98245 22 3.19009 22H20.8099C22.0175 22 23 20.9735 23 19.7117V8.00763C23 6.74586 22.0175 5.7193 20.8099 5.7193ZM9.32765 3.72343C9.32765 3.57804 9.44087 3.4598 9.58001 3.4598H14.4199C14.5591 3.4598 14.6723 3.57809 14.6723 3.72343V5.7193H9.32765V3.72343ZM2.39713 8.00763C2.39713 7.55076 2.75283 7.1791 3.19009 7.1791H20.8099C21.2471 7.1791 21.6029 7.55076 21.6029 8.00763V9.08792C21.6029 10.1012 20.9526 11.0067 20.0215 11.2899L12.7151 13.5126C12.2473 13.655 11.7527 13.655 11.2848 13.5126L3.97851 11.2899C3.04741 11.0067 2.39713 10.1012 2.39713 9.08792V8.00763ZM20.8099 20.5402H3.19009C2.75288 20.5402 2.39713 20.1686 2.39713 19.7118V12.0599C2.74917 12.3442 3.15045 12.5584 3.58793 12.6915C11.6589 15.1468 11.2441 15.0793 12 15.0793C12.7658 15.0793 12.3316 15.1497 20.412 12.6915C20.8496 12.5584 21.2508 12.3442 21.6028 12.0599V19.7117C21.6029 20.1685 21.2471 20.5402 20.8099 20.5402Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default JobIcon;
